import { defineMessages } from 'react-intl'

export default defineMessages({
  currencyLabel: {
    id: 'pay_currency',
    defaultMessage: 'Currency',
  },
})
